import React from "react";
import { Container, Row, Col, Card, Image, Button } from "react-bootstrap";
import imgDevin from "../../Assets/Personil/devin.jpg";
import imgIno from "../../Assets/Personil/ino.jpg";
import imgJojo from "../../Assets/Personil/jojo.jpg";
import imgKlency from "../../Assets/Personil/klency.jpg";
import imgMark from "../../Assets/Personil/mark.jpg";
import imgRachel from "../../Assets/Personil/rachel.jpg";
import imgJazz from "../../Assets/Genre/jazz.png";
import imgRbsoul from "../../Assets/Genre/rbsoul.png";
import imgPop from "../../Assets/Genre/pop.png";

function Home2() {
  const chatUs = () => {
    window.open("https://api.whatsapp.com/send/?phone=6287772787447&text&app_absent=0", '_blank', 'noopener, noreferrer');
  };

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        {/* Genres Section */}
        <Row className="home-about-description justify-content-md-center" style={{ paddingBottom: 20 }}>
            <Col md={8}>
                <h1 style={{ fontSize: "2.6em" }}>
                    Music Genres
                </h1>
            </Col>
        </Row>
        <Row className="justify-content-md-center">
          <Col md={4} className="genres-card">
            <Card className="genres-card-view">
              <Image src={imgJazz} alt="card-img" fluid />
                <Card.Title style={{paddingTop: 10, fontSize: "2em"}}>Jazz</Card.Title>
            </Card>
          </Col>
          
          <Col md={4} className="genres-card">
            <Card className="genres-card-view">
              <Image src={imgRbsoul} alt="card-img" fluid />
                <Card.Title style={{paddingTop: 10, fontSize: "2em"}}>RnB & Soul</Card.Title>
            </Card>
          </Col>
          
          <Col md={4} className="genres-card">
            <Card className="genres-card-view">
              <Image src={imgPop} alt="card-img" fluid />
                <Card.Title style={{paddingTop: 10, fontSize: "2em"}}>Pop</Card.Title>
            </Card>
          </Col>
        </Row>

        {/* Performer Section */}
        <Row className="home-about-description justify-content-md-center">
            <Col md={8}>
                <h1 style={{ fontSize: "2.6em", paddingTop: 30 }}>
                    Here's Our Main Performer
                </h1>
            </Col>
        </Row>

        <Row className="justify-content-md-center">
          <Col md={4} className="personil-card">
            <Card className="personil-card-view">
              <Image src={imgMark} alt="card-img" fluid />
                <Card.Title style={{paddingTop: 10, fontSize: "2em"}}>Mark</Card.Title>
            </Card>
          </Col>
          
          <Col md={4} className="personil-card">
            <Card className="personil-card-view">
              <Image src={imgRachel} alt="card-img" fluid />
                <Card.Title style={{paddingTop: 10, fontSize: "2em"}}>Rachel</Card.Title>
            </Card>
          </Col>
        </Row>

        <Row className="justify-content-md-center">
          <Col md={3} className="personil-card">
            <Card className="personil-card-view">
              <Image src={imgKlency} alt="card-img" fluid />
                <Card.Title style={{paddingTop: 10, fontSize: "2em"}}>Klency</Card.Title>
            </Card>
          </Col>
          
          <Col md={3} className="personil-card">
            <Card className="personil-card-view">
              <Image src={imgDevin} alt="card-img" fluid />
                <Card.Title style={{paddingTop: 10, fontSize: "2em"}}>Devin</Card.Title>
            </Card>
          </Col>
          
          <Col md={3} className="personil-card">
            <Card className="personil-card-view">
              <Image src={imgJojo} alt="card-img" fluid />
                <Card.Title style={{paddingTop: 10, fontSize: "2em"}}>Jojo</Card.Title>
            </Card>
          </Col>
          
          <Col md={3} className="personil-card">
            <Card className="personil-card-view">
              <Image src={imgIno} alt="card-img" fluid />
                <Card.Title style={{paddingTop: 10, fontSize: "2em"}}>Ino</Card.Title>
            </Card>
          </Col>
        </Row>

        {/* Packages Section */}
        {/* <Row className="home-about-description justify-content-md-center">
            <Col md={8}>
                <h1 style={{ fontSize: "2.6em", paddingTop: 30 }}>
                    Our Packages
                </h1>
            </Col>
        </Row>

        <Row className="justify-content-md-center">
          <Col md={4} className="package-card">
            <Card className="package-card-view">
              <Card.Title style={{paddingTop: 10, fontSize: "1.8em"}}>Live Music Entertain</Card.Title>
              <Card.Text>
                <br/>
                A customized & personalized music performance
                <br/><br/><br/>
                -----<br/>
                <p style={{textAlign: 'left'}}>
                • High quality entertainer<br/>
                • Personalized playlist<br/>
                • Stage manager
                </p>
                -----<br/>
              </Card.Text>
              <Card.Subtitle>
                <a href="https://api.whatsapp.com/send/?phone=6287772787447&text&app_absent=0" target="_blank" rel="noopener noreferrer" >
                  Chat Us
                </a>
              </Card.Subtitle>
            </Card>
          </Col>
          
          <Col md={4} className="package-card">
            <Card className="package-card-view">
              <Card.Title style={{paddingTop: 10, fontSize: "1.8em"}}>Master of Ceremony</Card.Title>
              <Card.Text>
                <br/>
                A professional MC to lead your memorable moments
                <br/><br/><br/>
                -----<br/>
                <p style={{textAlign: 'left'}}>
                • Male / Female MC<br/>
                • Presenting in Bahasa, English, <br/>or Multilingual setting
                </p>
                -----<br/>
              </Card.Text>
              <Card.Subtitle>
                <a href="https://api.whatsapp.com/send/?phone=6287772787447&text&app_absent=0" target="_blank" rel="noopener noreferrer" >
                  Chat Us
                </a>
              </Card.Subtitle>
            </Card>
          </Col>
          
          <Col md={4} className="package-card">
            <Card className="package-card-view">
              <Card.Title style={{paddingTop: 10, fontSize: "1.8em"}}>Sound System</Card.Title>
              <Card.Text>
                <br/>
                The best sound settings for any kind of events
                <br/><br/>
                -----<br/>
                <p style={{textAlign: 'left'}}>
                • Complete sound settings<br/>
                • Music instruments<br/>
                • Professional sound crews and operator
                </p>
                -----
              </Card.Text>
              <Card.Subtitle>
                <a href="https://api.whatsapp.com/send/?phone=6287772787447&text&app_absent=0" target="_blank" rel="noopener noreferrer" >
                  Chat Us
                </a>
              </Card.Subtitle>
            </Card>
          </Col>
        </Row> */}
        
        {/* <Row style={{ justifyContent: "center", position: "relative", paddingTop: 40 }}>
          <Button onClick={chatUs}>Chat Us</Button>
        </Row> */}
      </Container>
    </Container>
  );
}
export default Home2;
